// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"278c5f13","275":"41526688","322":"cd4cc171","388":"d5cfb59d"}[chunkId] + ".chunk.css";
};